import React, { useState } from "react";
import PharmacySuppliersPanel from "../components/pharmacy/PharmacySuppliersPanel";
import InventoryManager from "../components/manager/inventory/InventoryManager";
import ConsultantList from "../components/manager/consultants/ConsultantList";
import ConsultantLedger from "../components/manager/consultants/ConsultantLedger";

import "./Ledgers.css";

type LedgerTab = "drugs" | "supplies" | "consultants";

const TABS: { id: LedgerTab; label: string; sub: string }[] = [
  { id: "drugs", label: "Drug Suppliers", sub: "Pharmacy vendor ledger" },
  { id: "supplies", label: "Clinic Supplies", sub: "Materials & equipment ledger" },
  { id: "consultants", label: "Consultants", sub: "Consultant payout ledger" },
];

export default function Ledgers() {
  const [activeTab, setActiveTab] = useState<LedgerTab>("drugs");
  const [selectedConsultant, setSelectedConsultant] = useState<{ id: number; name: string } | null>(null);

  return (
    <div className="ledger-page">
      <header className="ledger-header">
        <div>
          <h1>Ledgers</h1>
          <p>Track supplier payables, consultant payouts, and internal finance records.</p>
        </div>
        <div className="ledger-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={activeTab === tab.id ? "active" : ""}
              onClick={() => setActiveTab(tab.id)}
            >
              <span>{tab.label}</span>
              <small>{tab.sub}</small>
            </button>
          ))}
        </div>
      </header>

      <section className="ledger-body">
        {activeTab === "drugs" && (
          <div className="ledger-panel">
            <PharmacySuppliersPanel />
          </div>
        )}

        {activeTab === "supplies" && (
          <div className="ledger-panel">
            <InventoryManager />
          </div>
        )}

        {activeTab === "consultants" && (
          <div className="ledger-panel ledger-consultants">
            <div className="ledger-consultants-list">
              <ConsultantList selected={selectedConsultant} onSelect={setSelectedConsultant} />
            </div>
            <div className="ledger-consultants-detail">
              {selectedConsultant ? (
                <ConsultantLedger consultant={selectedConsultant} />
              ) : (
                <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>
                  Please select a consultant from the list to view their ledger.
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
